<template>
	<div class="py-4 container-fluid">
    <div class="row">
        <div class="col-md-12">
					<div class="card" v-if="isLoading">
						<Loading/>
					</div>
          <div class="card" v-if="!isLoading">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0">Instalación {{ install.Name }}</p>
              </div>
            </div>
            <div class="card-body">
              <p class="text-uppercase text-sm">	Detalles</p>
              <div class="row">
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Contrato</label
                  >
                  <argon-input type="text" v-model="install.Campana__c.Name" disabled="true" />
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Estado</label
                  >
                  <argon-input type="text" v-model="install.Estado__c" disabled="true" />
                </div>
								<div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Marca</label
                  >
                  <argon-input type="text" v-model="install.Marca__c" disabled="true" />
                </div>
								<div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Fecha Instalación</label
                  >
                  <argon-input type="text" v-model="install.FechaInstalacion__c" disabled="true" />
                </div>
              </div>
              <hr class="horizontal dark" />
              <p class="text-uppercase text-sm" v-if="install.Estado__c=='Instalada'">	Detalles de instalación</p>
							<div class="row" v-if="install.Estado__c=='Instalada'">
                <div class="col-md-6 mt-2" v-if="install.Foto1URL__c!=null">
									<img width="300	" v-bind:src="'data:image/jpeg;base64,'+images.img1" @click="showImg(0)"/>
								</div>
								<div class="col-md-6 mt-2" v-if="install.Foto2URL__c!=null">
									<img width="300" v-bind:src="'data:image/jpeg;base64,'+images.img2" @click="showImg(1)"/>
								</div>
								<div class="col-md-6 mt-2" v-if="install.Foto3URL__c!=null">
									<img width="300" v-bind:src="'data:image/jpeg;base64,'+images.img3" @click="showImg(2)"/>
								</div>
								<div class="col-md-6 mt-2" v-if="install.Foto4URL__c!=null">
									<img width="300" v-bind:src="'data:image/jpeg;base64,'+images.img4" @click="showImg(3)"/>
								</div>
              </div>
							<p class="text-uppercase text-sm" v-if="install.Estado__c!='Instalada'">	Detalles de no instalación</p>
							<div class="row" v-if="install.Estado__c!='Instalada'">
                <div class="col-md-6 mt-2" v-if="install.FotoVisita1URL__c!=null">
									<img  width="300" v-bind:src="'data:image/jpeg;base64,'+images.img5" @click="showImg(0)"/>
								</div>
								<div class="col-md-6 mt-2" v-if="install.FotoVisita2URL__c!=null">
									<img width="300" v-bind:src="'data:image/jpeg;base64,'+images.img6" @click="showImg(1)"/>
								</div>
								<div class="col-md-6 mt-2" v-if="install.FotoVisita3URL__c!=null">
									<img width="300" v-bind:src="'data:image/jpeg;base64,'+images.img7" @click="showImg(2)"/>
								</div>
								<div class="col-md-12">
									<label for="example-text-input" class="form-control-label"
                    >Razón de no instalación</label
                  >
                  <argon-input type="text" v-model="install.UltimaRazonNoInstalacion__c" disabled="true" />
								</div>
								<div class="col-md-12" v-if="UltimoComentarioNoInstalacion__c!=null">
									<label for="example-text-input" class="form-control-label"
                    >Comentario</label
                  >
                  <p >{{ UltimoComentarioNoInstalacion__c }}</p>
								</div>
                
              </div>
              <vue-easy-lightbox
                :visible="visibleRef"
                :imgs="imgsRef"
                :index="indexRef"
                @hide="onHide"
                />
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
  import Loading from '../../examples/Loading.vue';
  import moment from 'moment';
	import ArgonInput from "@/components/ArgonInput.vue";
  import axios from 'axios';
  import VueEasyLightbox from 'vue-easy-lightbox'; 
  export default {
    name: "tables",
    components: {
      Loading,
      VueEasyLightbox,
			ArgonInput,
    },
    data() {
      return {
        visibleRef: false,
        indexRef: 0,
        imgsRef:[],
        install:{
					Name:null,
					Campana__c:{
						Name:null
					},
					Estado__c:null,
					Marca__c:null,
					FechaInstalacion__c:null
				},
        isLoading:false,
        images:{
          img1:null,
          img2:null,
          img3:null,
          img4:null,
          img5:null,
          img6:null,
          img7:null
        }
      };
    },
    methods:{
      async fetchInstalls(){
        this.isLoading=true;
				let idInstall = this.$route.params.id;
        fetch(this.$EndPoint+'instalaciones/install/'+idInstall)
        .then(response=>response.json())
        .then(async result=>{
          console.log(result);
          this.install=result;
          this.isLoading=false;
          axios.post(this.$EndPoint+'users/sptoken')
          .then((result)=>{
            console.log(result.data);
            localStorage.setItem('spToken', result.data);
          });
          
          if(this.install.Foto1URL__c!=null){
            await this.fetchImg(this.install.Foto1URL__c,1);
          }
          if(this.install.Foto2URL__c!=null){
            await this.fetchImg(this.install.Foto2URL__c,2);
          }
          if(this.install.Foto3URL__c!=null){
            await this.fetchImg(this.install.Foto3URL__c,3);
          }
          if(this.install.Foto4URL__c!=null){
            await this.fetchImg(this.install.Foto4URL__c,4);
          }
          if(this.install.FotoVisita1URL__c!=null){
            await this.fetchImg(this.install.FotoVisita1URL__c,5);
          }
          if(this.install.FotoVisita2URL__c!=null){
            await this.fetchImg(this.install.FotoVisita2URL__c,6);
          }
          if(this.install.FotoVisita3URL__c!=null){
            await this.fetchImg(this.install.FotoVisita3URL__c,7);
          }
          
        })
      },

      async fetchImg(url,type){
        let imgResult = null;
        const token = localStorage.getItem('spToken');
          // Verifica si hay un token disponible
          if (!token) {
            console.error('No se encontró un token de acceso en el almacenamiento local.');
          } else {
            let startIndex = url.indexOf('/sites');
            let modifiedURL = url.slice(startIndex);
            let baseUrl = 'https://dicoracom.sharepoint.com/sites/Instalaciones/_api/web';
            let moddURL = `/GetFileByServerRelativeUrl('${modifiedURL}')/openbinarystream`;
            let newUrl = `${baseUrl}${moddURL}`;
            
            axios.get(newUrl, {
              headers: {
                  'Authorization': `Bearer ${token}`
              },
              responseType: 'arraybuffer' // Para manejar la respuesta como un arreglo de bytes (imagen)
            })
            .then((response) => {
              // Aquí puedes manejar la respuesta de la imagen
              console.log(response); // La respuesta será un arreglo de bytes de la imagen
              imgResult = response.data;
              
              function arrayBufferToBase64(buffer) {
                let binary = '';
                let bytes = new Uint8Array(buffer);
                let len = bytes.byteLength;
                for (let i = 0; i < len; i++) {
                    binary += String.fromCharCode(bytes[i]);
                }
                return window.btoa(binary);
              }

              switch(type){
                case 1:
                  this.images.img1=arrayBufferToBase64(imgResult);
                  this.imgsRef.push('data:image/jpeg;base64,' +this.images.img1); 
                  break;
                case 2:
                  this.images.img2=arrayBufferToBase64(imgResult);
                  this.imgsRef.push('data:image/jpeg;base64,' +this.images.img2);
                  break;
                case 3:
                  this.images.img3=arrayBufferToBase64(imgResult);
                  this.imgsRef.push('data:image/jpeg;base64,' +this.images.img3);
                  break;
                case 4:
                  this.images.img4=arrayBufferToBase64(imgResult);
                  this.imgsRef.push('data:image/jpeg;base64,' +this.images.img4);
                  break;
                case 5:
                  this.images.img5=arrayBufferToBase64(imgResult);
                  this.imgsRef.push('data:image/jpeg;base64,' +this.images.img5);
                break;
                  case 6:
                  this.images.img6=arrayBufferToBase64(imgResult);
                  this.imgsRef.push('data:image/jpeg;base64,' +this.images.img6);
                  break;
                case 7:
                  this.images.img7=arrayBufferToBase64(imgResult);
                  this.imgsRef.push('data:image/jpeg;base64,' +this.images.img7);
                  break;
              }
            
            return imgResult;
            })
            .catch((error) => {
                console.log(error);
                console.error('Error al obtener la imagen:', error.response ? error.response.data : error.message);
            });
          }
      },
      getFormattedDate(date) {
        return moment(date).format("YYYY-MM-DD")
      },
      showImg(index) {
        this.indexRef = index; // Set the image to display first
        this.visibleRef = true;  // Make the lightbox visible
      },
      onHide() {
        this.visibleRef = false;
      }
    },
    created(){
      if(localStorage.getItem('IsLoggedIn')=='true'){
        this.fetchInstalls();
      }else{
        this.$router.push('/signin')
      }
    }
  };
</script>